export default __webpack_public_path__ + "0d2912e3c3e4edf8db798d826d3c9932.png";